module.exports = __webpack_public_path__ + "img/Fatturato_2022-IT.851b6f21.png";